var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from 'react-tooltip';
import { v4 as uuidv4 } from 'uuid';
import 'react-tooltip/dist/react-tooltip.css';
import { getDayMonth } from '../../utils/formatDate';
import createClasses from '../../utils/classes';
var buildDataAttributes = function (attributes) {
    if (attributes === void 0) { attributes = {}; }
    var value = {};
    Object.keys(attributes).forEach(function (name) {
        value["data-".concat(name.toLowerCase())] = attributes[name];
    });
    return value;
};
var Basic = function (props) {
    var id = props.id, _a = props.classes, classes = _a === void 0 ? [] : _a, dataSet = props.dataSet, end = props.end, start = props.start, style = props.style, title = props.title, titleStyle = props.titleStyle, tooltip = props.tooltip, _b = props.tooltipStyle, tooltipStyle = _b === void 0 ? {} : _b, tooltipFollowCursor = props.tooltipFollowCursor, altId = props.altId, continuing = props.continuing;
    var defaultTooltipStyle = {
        color: 'white',
        lineHeight: '1.3',
        textAlign: 'left',
        padding: '10px',
        background: '#4c4c4c',
    };
    var tooltipId = "rt-tooltip-".concat(altId !== null && altId !== void 0 ? altId : uuidv4());
    return (_jsxs("div", __assign({ id: id, "data-altid": altId, className: createClasses('rt-element', classes), style: style, "data-tooltip-id": tooltipId }, buildDataAttributes(dataSet), { children: [_jsxs("div", __assign({ className: "rt-element__content", "aria-hidden": "true" }, { children: [_jsx("span", __assign({ className: "rt-element__title", style: titleStyle }, { children: title })), continuing || _jsx(_Fragment, {})] })), tooltip ? (_jsx("div", __assign({ className: "rt-element__tooltip", style: tooltipStyle }, { children: tooltip }))) : (_jsxs(Tooltip, __assign({ id: tooltipId, float: tooltipFollowCursor, style: __assign(__assign({}, defaultTooltipStyle), tooltipStyle), noArrow: true, place: "top", offset: 25, delayShow: 300, delayHide: 300 }, { children: [_jsx("div", { children: title }), _jsxs("div", { children: [_jsx("strong", { children: "Start" }), " ", getDayMonth(start)] }), _jsxs("div", { children: [_jsx("strong", { children: "End" }), " ", getDayMonth(end)] })] })))] })));
};
export default Basic;
